// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_ew-b";
export var colorBlue = "_ew-8";
export var colorDot = "_ew-0";
export var colorDotLarge = "_ew-2";
export var colorDotSmall = "_ew-1";
export var colorGreen = "_ew-7";
export var colorGrey = "_ew-3";
export var colorOrange = "_ew-5";
export var colorPink = "_ew-a";
export var colorPurple = "_ew-9";
export var colorRed = "_ew-4";
export var colorYellow = "_ew-6";